import { fetcher } from "../fetcher";

type GetDecisionParams = {
  client_project_id: number; // The id of an existing record in the client_projects table. Example: 1
  order_by?:
    | "id"
    | "name"
    | "decision_date"
    | "status"
    | "status_changed_at"
    | "created_at"
    | "updated_at";
};
export const decisionService = {
  getDecision: async (params?: GetDecisionParams) => {
    const paramsWithDefaults = {
      ...params,
      order_by: params?.order_by ?? ("decision_date" as const),
    };

    return await fetcher(`/decisions/all`, {
      method: "GET",
      params: paramsWithDefaults,
      schema: decisionsSchema,
    });
  },
  setDecisionStatus: async (payload: SetDecisionStatusPayload) => {
    const { status, decision_id, ...rest } = payload;
    return await fetcher(`/decisions/${decision_id}/change-status`, {
      method: "POST",
      body: { status: status, ...rest },
    });
  },
};
